<template>
  <div class="furniture-card-mobile" :class="{active: isActive}">
    <div class="furniture-card-mobile__body">
      <div class="furniture-card-mobile__body__icon icon" :class="notNullIcon"/>
      <span class="furniture-card-mobile__body__label">{{label}}</span>
    </div>
    <div class="furniture-card-mobile__tools"
         :class="{hidden: !showTools}">
      <img class="furniture-card-mobile__tools__img"
           alt="disassemble"
           @click="onToolsClicked"
           :src="toolSrc"
      />
    </div>
    <div class="furniture-card-mobile__counter">
      <div class="furniture-card-mobile__counter__button"
           @click="$emit('input', value - step)"
           :class="{'furniture-card-mobile__counter__button--clickable': value > min}"
      >
        <font-awesome-icon :icon="['fas','minus']" />
      </div>
      <div class="furniture-card-mobile__counter__value">{{ value }}</div>
      <div class="furniture-card-mobile__counter__button"
           @click="$emit('input', value + step)"
           :class="{'furniture-card-mobile__counter__button--clickable': value < max}"
      >
        <font-awesome-icon :icon="['fas','plus']" />
      </div>
    </div>
  </div>
</template>

<script>
import activeTool from '@/assets/img/mobile_tools.png';
import unActiveTool from '@/assets/img/mobile_disable_tools.png';

export default {
  name: 'FurnitureCardMobile',
  props: {
    disassemble: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 0,
    },
    step: {
      type: Number,
      default: 1,
    },
    vertical: { type: Boolean, default: false },
    canDisassemble: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    toolSrc() {
      if (this.disassemble) {
        return activeTool;
      }
      return unActiveTool;
    },
    isActive() {
      return this.value > 0;
    },
    showTools() {
      return this.canDisassemble && this.isActive;
    },
    notNullIcon() {
      return this.icon || 'default';
    },
  },
  methods: {
    onToolsClicked() {
      this.$emit('update:disassembly', !this.disassemble);
    },
  },
};
</script>

<style scoped lang="scss">
  .hidden{
    visibility: hidden;
  }
  .furniture-card-mobile {
    user-select: none;
    margin: 0;
    display: grid;
    border: 0.5px solid $--next-grey-blue;
    border-radius: $--border-radius-base;
    place-content: center;
    grid-template-columns: 1fr 40px 90px;
    grid-template-rows: none;
    text-align: center;
    height: 48px;

    &__tools {
      display: flex;
      place-self: center;
      place-content: center;
      align-content: center;
      align-self: center;
      width: 100%;
      height: 100%;
      &__img{
        margin: auto;
        height: 19px;
        width: 19px;
      }
    }

    &__body {
      display: grid;
      justify-items: start;
      align-items: center;
      border: none;
      padding: 0 .3em;

      &__label {
        overflow-wrap: break-word;
        font-size: $--font-size-small;
        margin: .8em;
        text-align: start;
      }
    }

    &__counter {
      display: grid;
      grid-template-columns: auto 1fr auto;
      color: $--color-text-secondary;
      place-items: center;
      align-items: center;

      &__value {
        display: grid;
        place-items: center;
        align-items: center;
        font-size: $--font-size-medium;
        text-align: center;
        place-self: stretch;
        border: none;
      }

      &__button {
        display: grid;
        place-items: center;
        align-items: center;
        font-size: 12px;
        width: 30px;

        &--clickable {
          cursor: pointer;
        }

        svg {
          margin: auto;
        }
      }
    }
  }
  .active{
    border: 1px solid $--color-primary;
  }

</style>
